// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_WorkOrderUpdateStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/work_order_update_status/{work_order_id}
 *
 * Returns the work order id and its new status.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_WorkOrderUpdateStatusResponseDados {
work_order_id: number
status: string
}

export type Orders_WorkOrderUpdateStatusResponse = ApiResponse<Orders_WorkOrderUpdateStatusResponseDados>;

registerResponseContract('Orders_WorkOrderUpdateStatusResponse', {
  work_order_id: { type: 'number',  required: true },
  status:        { type: 'string',  required: true },
})
